module.exports = __webpack_public_path__ + "static/media/brand_lift_user_guide.pdf";